module.exports = __webpack_public_path__ + "static/media/Tire-bright-red.b78dace0.svg";